import { TOOLTIP_AUTOHIDE_TIME } from '../Underline/constants';

/**
 * We are using this utility function on the tooltip onShow lifecycle hook
 * in order to autohide the filter match tooltip that was shown upon creation
 * after a certain time has elapsed
 */
export const autoHideTooltipAfterTimeout = (tooltip: { hide: () => void }): false | void => {
  setTimeout(() => {
    tooltip.hide();
  }, TOOLTIP_AUTOHIDE_TIME);
};
